import { z } from 'zod';
import { AppSettingsSchema, AppSettingsAssetsSchema } from '@andor/contracts/settings';
export const assetEntitySchema = AppSettingsAssetsSchema.shape.darkBackground;
export type TAppAsset = z.infer<typeof assetEntitySchema>;
export const styleEntitySchema = AppSettingsSchema.shape.styles.element;
export type TAppStyle = z.infer<typeof styleEntitySchema>;
export const appColorModeSchema = AppSettingsSchema.shape.colorMode;
export type TAppColorMode = z.infer<typeof appColorModeSchema>;
export const appConfigSchema = AppSettingsSchema;
// Editors may hold an incomplete asset map while a file is being selected.
export type AppConfig = Omit<z.infer<typeof appConfigSchema>, 'assets'> & {
  assets: Record<string, TAppAsset>;
};
export const appLanguageSchema = z.enum([
  'en', // English (Default)
  'de', // German
  'fr', // French
  'es', // Spanish
  'hu', // Hungarian
  'it', // Italian
  'pl', // Polish
  'pt', // Portuguese
  'tr', // Turkish
]);

export type TAppLanguage = z.infer<typeof appLanguageSchema>;
